import moment from "moment";

function DateTimeAppointmentBtn({ date }: { date?: string | number }) {
  return (
    <div className="flex flex-wrap items-center gap-1">
      <div className="rounded-[4px] border border-primary-40 bg-primary-click px-1.5 py-0.5 text-sm font-bold text-primary">
        {moment(moment(date, "MM/DD/YYYY h:mm:ss A")).format("DD MMM YYYY")}
      </div>
      <div className="rounded-[4px] border border-primary-40 bg-primary-click px-1.5 py-0.5 text-sm font-bold text-primary">
        {/* {moment(moment(date, "MM/DD/YYYY h:mm:ss A")).format("h:mm A")}  */}
        {moment(date).format("hh:mm A")}
      </div>
    </div>
  );
}

export default DateTimeAppointmentBtn;
